import Vue from 'vue'
import auth from "@/auth/authService";
import { api } from './utils/requests';
import store from "./store/store"

import { IonicVueRouter } from '@ionic/vue'
Vue.use(IonicVueRouter)

const router = new IonicVueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [

                {
                    path: '/',
                    redirect: '/dashboard',
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/dashboard',
                    name: 'dashboard-analytics',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/dashboard2',
                    name: 'dashboard2',
                    component: () => import('./views/Dashboard2.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/dashboard3',
                    name: 'dashboard3',
                    component: () => import('./views/Dashboard3.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/status-dashboard',
                    name: 'status-dashboard',
                    component: () => import('./views/StatusDashboard.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/notifications',
                    name: 'notifications',
                    component: () => import('./views/Notification/Notification.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/users/browse',
                    name: 'users-list',
                    component: () => import('./views/Organisation/ListUsers.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/users/new',
                    name: 'users-create',
                    component: () => import('./views/Organisation/EditUser.vue'),
                    meta: {
                        rule: 'subscriber',
                        organisation_rules: ['a',]
                    }
                },
                {
                    path: '/users/:user_id',
                    name: 'users-edit',
                    component: () => import('./views/Organisation/EditUser.vue'),
                    meta: {
                        rule: 'subscriber',
                        organisation_rules: ['a',]
                    }
                },
                {
                    path: '/asset-register/browse',
                    name: 'asset-register-list',
                    component: () => import('./views/AssetRegister/List.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/asset-register/new/',
                    name: 'asset-register-new',
                    component: () => import('./views/AssetRegister/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e'
                    }
                },
                {
                    path: '/asset-register/:asset_id',
                    name: 'asset-register-edit',
                    component: () => import('./views/AssetRegister/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e'
                    }
                },
                {
                    path: '/asset-register/view/:asset_id',
                    name: 'asset-register-view',
                    component: () => import('./views/AssetRegister/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'v'
                    }
                },
                {
                    path: '/issues/new/:issue_type',
                    name: 'issues-new',
                    component: () => import('./views/Issue/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e'
                    }
                },
                {
                    path: '/issues/:issue_type/edit/:issue_id',
                    name: 'issues-edit',
                    component: () => import('./views/Issue/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e'
                    }
                },
                {
                    path: '/issues/:issue_type/view/:issue_id',
                    name: 'issues-view',
                    component: () => import('./views/Issue/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'v'
                    }
                },
                // for caching
                {
                    path: 'cache/issues/:issue_type/view/:issue_id',
                    name: 'cache-issue-view',
                    component: () => import('./views/Issue/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'v',
                        use_cache: true
                    }
                },
                {
                    path: 'cache/issues/:issue_type/edit/:issue_id',
                    name: 'cache-issue-edit',
                    component: () => import('./views/Issue/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e',
                        use_cache: true
                    }
                },
                {
                    path: 'cache/list/:issue_type',
                    name: 'cache-list',
                    component: () => import('./views/Issue/CacheList.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: true
                },
                {
                    path: '/issues/:issue_type/:issue_id/approve',
                    name: 'issues-approve',
                    component: () => import('./views/Issue/Approve.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/issues/:issue_type/:issue_id/resolution',
                    name: 'issues-resolution',
                    component: () => import('./views/Issue/Resolution.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/issues/:issue_type',
                    name: 'issues-list',
                    component: () => import('./views/Issue/List.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: true
                },
                // issue linking
                {
                    path: '/issues/:issue_type/:issue_id/link',
                    name: 'issue-link',
                    component: () => import('./views/Issue/OnlineList.vue'),
                    props: {
                        is_linking: true
                    },
                    meta: {
                        rule: 'subscriber',
                    },
                },
                {
                    path: '/issues/:issue_type/report',
                    name: 'issues-report-list',
                    component: () => import('./views/Issue/OnlineList.vue'),
                    props: {
                        report_mode: true
                    },
                    meta: {
                        rule: 'subscriber',
                    },
                },
                {
                    path: '/reports',
                    name: 'issues-reports',
                    component: () => import('./views/Reports/Report.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/reports/strip-chart',
                    name: 'strip-chart',
                    component: () => import('./views/Reports/StripChart.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/stocks',
                    name: 'stock-list',
                    component: () => import('./views/Stock/List.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/stock/new',
                    name: 'stock-new',
                    component: () => import('./views/Stock/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/stock/:stock_id',
                    name: 'stock-edit',
                    component: () => import('./views/Stock/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/stock-logs',
                    name: 'stock-log-list',
                    component: () => import('./views/Stock/LogList.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/stock-log/new',
                    name: 'stock-log-new',
                    component: () => import('./views/Stock/LogEdit.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/master/year',
                    name: 'master-year',
                    component: () => import('./views/Master/MasterYear.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/master/item-group',
                    name: 'master-item-group',
                    component: () => import('./views/Master/MasterItemGroup.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/master/item-sub-group',
                    name: 'master-item-sub-group',
                    component: () => import('./views/Master/MasterItemSubGroup.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/master/lane',
                    name: 'master-lane',
                    component: () => import('./views/Master/MasterLane.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/master/uom',
                    name: 'master-uom',
                    component: () => import('./views/Master/MasterUOM.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/master/side',
                    name: 'master-side',
                    component: () => import('./views/Master/MasterSide.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/master/vendor',
                    name: 'master-vendor',
                    component: () => import('./views/Master/MasterVendor.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/purchase-order',
                    name: 'purchase-order',
                    component: () => import('./views/PurchaseOrder/PurchaseOrder.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/purchase-order-detail',
                    name: 'purchase-order-detail',
                    component: () => import('./views/PurchaseOrder/PurchaseOrderDetail.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/drp-transaction',
                    name: 'drp-transaction',
                    component: () => import('./views/DRPTransaction/DRPTransaction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/master/budget',
                    name: 'budget-master',
                    component: () => import('./views/Master/BudgetMaster.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/stock-log/:stock_log_id',
                    name: 'stock-log-edit',
                    component: () => import('./views/Stock/LogEdit.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/dpr/:issue_type/:module_key/entries',
                    name: 'dpr-entries',
                    component: () => import('./views/DPR/EntryList.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/dpr/:issue_type/:module_key/entries/report',
                    name: 'dpr-entries-reports',
                    component: () => import('./views/DPR/OnlineEntryList.vue'),
                    props: {
                        report_mode: true
                    },
                    meta: {
                        rule: 'subscriber',
                    }
                },
                //report for DPR
                {
                    path: '/dpr/reports',
                    name: 'dpr-reports',
                    component: () => import('./views/Reports/DprReports.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/dpr/:issue_type/:module_key/entry/add',
                    name: 'dpr-entry-add',
                    component: () => import('./views/DPR/EntryAdd.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e'
                    }
                },
                {
                    path: '/dpr/:issue_type/:module_key/entry/:dpr_entry_id',
                    name: 'dpr-entry-edit',
                    component: () => import('./views/DPR/EntryAdd.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e'
                    }
                },
                {
                    path: '/dpr/:issue_type/:module_key/entry/:dpr_entry_id/view',
                    name: 'dpr-entry-view',
                    component: () => import('./views/DPR/EntryAdd.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'v'
                    }
                },
                //for caching dpr issues
                {
                    path: 'cache/dpr/:issue_type/:module_key/entry/:dpr_entry_id/view',
                    name: 'cache-dpr-entry-view',
                    component: () => import('./views/DPR/EntryAdd.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'v',
                        use_cache: true
                    }
                },
                {
                    path: 'cache/dpr/:issue_type/:module_key/entry/:dpr_entry_id',
                    name: 'cache-dpr-entry-edit',
                    component: () => import('./views/DPR/EntryAdd.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e',
                        use_cache: true
                    }
                },
                {
                    path: 'cache/dpr/:issue_type/:module_key/entries',
                    name: 'cache-dpr-entries',
                    component: () => import('./views/DPR/OfflineEntryList.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: true
                },
                {
                    path: '/dpr/:issue_type/month/:report_id',
                    name: 'dpr-report-view',
                    component: () => import('./views/DPR/DynamicView.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                //for report mode
                {
                    path: '/dpr/:issue_type/month/:report_id/report',
                    name: 'dpr-report-view-reports',
                    component: () => import('./views/Reports/RMDPRReport/MonthReport.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                // for billing purpose
                //for report mode
                {
                    path: '/dpr/:issue_type/month/:report_id/billing_report',
                    name: 'dpr-report-view-billing-reports',
                    component: () => import('./views/Reports/RMDPRReport/BillingReport.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/dpr/:issue_type/daily/',
                    name: 'dpr-report-transaction',
                    component: () => import('./views/DPR/DynamicViewTransaction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                // for report mode
                {
                    path: '/dpr/:issue_type/daily/report',
                    name: 'dpr-report-transaction-reports',
                    component: () => import('./views/Reports/RMDPRReport/DailyReport.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/reports/download',
                    name: 'reports-download',
                    component: () => import('./views/Reports/Exports.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                // safety programs
                {
                    path: '/safety-program',
                    name: 'safety-program-new',
                    component: () => import('./views/SafetyPrograms/SafetyProgramEdit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e'
                    }
                },
                {
                    path: '/safety-programs',
                    name: 'safety-program-list',
                    component: () => import('./views/SafetyPrograms/SafetyProgramList.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                },
                {
                    path: '/safety-program/:safety_program_id',
                    name: 'safety-program-edit',
                    component: () => import('./views/SafetyPrograms/SafetyProgramEdit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'e'
                    }
                },
                {
                    path: '/safety-program/view/:safety_program_id',
                    name: 'safety-program-view',
                    component: () => import('./views/SafetyPrograms/SafetyProgramEdit.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                    props: {
                        mode: 'v'
                    }
                },
                {
                    path: '/safety-program/:safety_program_id/approve',
                    name: 'safety-program-approve',
                    component: () => import('./views/SafetyPrograms/SafetyProgramApprove.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/safety-program/:safety_program_id/resolution',
                    name: 'safety-program-resolution',
                    component: () => import('./views/SafetyPrograms/SafetyProgramResolution.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                //safety program report
                {
                    path: '/safety-programs/report',
                    name: 'safety-program-report-list',
                    component: () => import('./views/SafetyPrograms/SafetyProgramList.vue'),
                    props: {
                        report_mode: true
                    },
                    meta: {
                        rule: 'subscriber',
                    },
                },
                {
                    path: '/report/safety-program',
                    name: 'safety-program-reports',
                    component: () => import('./views/Reports/SafetyProgramReport.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                // Budget vs Actual Report
                {
                    path: '/report/budget-actual',
                    name: 'budget-actual-report',
                    component: () => import('./views/Reports/BudgetActualReport.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                // Entry Report
                {
                    path: 'report/entries',
                    name: 'entries-report',
                    component: () => import('./views/Reports/EntryReport.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/synchronization',
                    name: 'synchronization',
                    component: () => import('./views/Synchronization.vue'),
                    meta: {
                        rule: 'subscriber',
                    },
                },
                // SAP PO
                {
                    path: 'sap-po/new/',
                    name: 'sap-po-create',
                    component: () => import('./views/SapPO/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: 'sap-po/:po_id/edit',
                    name: 'sap-po-edit',
                    component: () => import('./views/SapPO/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: 'sap-po/list',
                    name: 'sap-po-list',
                    component: () => import('./views/SapPO/List.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
            ],
        },
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '/choose-organisation',
                    name: 'organisation-chooser',
                    component: () => import('./views/Organisation/Chooser.vue'),
                    meta: {
                        rule: 'subscriber'
                    }
                },
                {
                    path: '/accounts/login',
                    name: 'page-login',
                    // redirect: api.base_auth_url + api.native_auth_urls.login,
                    component: () => import('@/views/pages/Login.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/sign-up',
                    name: 'page-sign-up',
                    // redirect: api.base_auth_url + api.native_auth_urls.login,
                    component: () => import('@/views/pages/Signup.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/register',
                    name: 'page-register',
                    component: () => import('@/views/pages/Register.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/delete',
                    name: 'page-delete',
                    component: () => import('@/views/pages/Delete.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/logout',
                    name: 'page-logout',
                    component: () => import('@/views/pages/Logout.vue'),
                    meta: {
                        rule: 'subscriber',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/forgot-password/:uid/:token',
                    name: 'page-forgot-password-validate',
                    component: () => import('@/views/pages/ForgotPasswordValidate.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                // {
                //     path: '/pages/comingsoon',
                //     name: 'page-coming-soon',
                //     component: () => import('@/views/pages/ComingSoon.vue'),
                //     meta: {
                //         rule: 'public'
                //     }
                // },
                {
                    path: '/errors/404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/errors/500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/errors/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/errors/offline',
                    name: 'page-offline',
                    component: () => import('@/views/pages/Offline.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            name: 'page-error-404',
            component: () => import('@/views/pages/Error404.vue'),
            meta: {
                rule: 'public'
            }
        }
    ],
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
    if (store.state.active_service_worker) {
        store.state.active_service_worker.update()
    }
})

router.beforeEach((to, from, next) => {
    // console.log("Accessing ", to.path, " and You're online? ", navigator.onLine)

    const next_url = to.fullPath

    // if(!navigator.onLine) {
    //     if(to.path != '/errors/offline'){
    //         // console.log("Redirected to offline")
    //         return next({name: 'page-offline', params: {next: to.path}})
    //     }
    //     else
    //         return next()
    // }

    if (to.query.autoload_organisation && to.name != 'organisation-chooser') {
        let updatedURL = to.fullPath.replace(/([&?])autoload_organisation=[0-9]*/, '');
        return next({ name: 'organisation-chooser', query: { next: updatedURL, autoload_organisation: to.query.autoload_organisation } })
    }

    if (!store.state.organisation.organisation && to.name != "organisation-chooser" && !to.meta.skip_organisation) {
        next({ name: 'organisation-chooser', query: { next: to.fullPath } })
    } else {
        if (to.meta.rule == 'admin' || to.meta.rule == 'subscriber') {
            auth.isAuthenticated().then((res) => {
                next()
            }, (err) => {
                if (to.name === 'forgot-password') {
                    next()
                } else {
                    console.log('Redirecting')
                    return next({ name: 'page-login', query: { next: next_url } })
                }
            })
        }
        else {
            next()
        }
    }

});

export default router
